// extracted by mini-css-extract-plugin
export var chip = "_c5-0";
export var filterDropdown = "_c5-5";
export var filterItem = "_c5-6";
export var icon = "_c5-1";
export var removeButton = "_c5-3";
export var removeIcon = "_c5-4";
export var separator = "_c5-2";